import ModalComponent from 'components/Common/Modal';
import useMailMergeFunctions from 'components/Dashboard/Influence/CrmEmails/MailMergeSection/useMailMergeFunctions';
import createNotification from 'components/Settings/Utilities/CreateNotification';
import { useState } from 'react';

const RemoveMailMergeDataModal = (props) => {
  const { refreshEmailData, id, isOpen, setIsOpen } = props;
  const { clearMailMerge } = useMailMergeFunctions();
  const source = new AbortController();
  const [isLoading, setIsLoading] = useState(null);

  const handleClearMailMerge = async () => {
    setIsLoading(true);
    const result = await clearMailMerge({ id });
    setIsLoading(null);
    setIsOpen(false);

    if (result?.status === 200) {
      await refreshEmailData(source, true);
      createNotification('success', 'Mail merge data cleared successfully');
    }
  };
  return (
    <ModalComponent
      maxWidth={500}
      isOpen={!!isOpen}
      setIsOpen={setIsOpen}
      overlayClassName='react-modal-overlay report-extra-index-modal z-extra-max-plus'
    >
      <div className='p-3 px-lg-5 pt-lg-5 pb-lg-2'>
        <div className='text-center'>
          <p>Are you sure you want to remove your mail merge data?</p>

          <div className='my-4'>
            <button
              className='general-button main-danger-button rounded-pill text-white rounded-5 px-4 py-2'
              onClick={async () => {
                await handleClearMailMerge();
              }}
            >
              {isLoading ? <i className='fas fa-spinner fa-spin'></i> : `Remove data`}
            </button>
          </div>
        </div>
      </div>
    </ModalComponent>
  );
};

export default RemoveMailMergeDataModal;
